module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAARJJREFUSIntVbFKxUAQ3NlobRHs/QQ/QMQfsLR4nY2V5BIsraxt4p1YpHtgLfgJwcJa/AJri2AhgpDbtYo8Yu4SeIgImWpudvZmt1qi/w5MMTnnFkR0QkTcaSLyTkTnRVE8x3o3pgSIyBmAvTzPPzutLMsdZr4mosNYb3ADa+1Fx1X1GMCy71nVAbwYY354ghswc73yrAO2b71t27chQzDAe3/PzE+heh9JkhARHUz1k3OuHjVN8POQ2Ie19mqMhzApAMDuGF8rYB3MAXPAHPDHAdsd8d4XMV5V1ZaIfAx9Ejs4NwBeVfWBmTUyyKaqngK4zbLsrl8M3oOmabI0TY8A7ItIcBAArapeGmMeI0P8Hr4AGe9hu2ogIeQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/delete.png
// module id = KuaY
// module chunks = 1